/* eslint-disable no-nested-ternary */
import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: null,
  appointments: [],
};

const slice = createSlice({
  name: 'appointment',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET elementS
    getelementsSuccess(state, action) {
      state.isLoading = false;
      state.appointments = action.payload;
    },

  },
});
export default slice.reducer;


export function getappointments(currentUser, paginate, pageIndex, pageSize) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const params = {};
      if (paginate) params.paginate = paginate;
      if (pageIndex) params.page = pageIndex;
      if (pageSize) params.per_page = pageSize;
      const url = currentUser === 'admin' ? 'api/admin/all_appointments' : currentUser === 'company' ? 'api/company/all_appointments' : '/api/clinic/appointments';
      const response = await axios.get(url, { params });
      dispatch(slice.actions.getelementsSuccess(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
